import IncomeDetailsView from "./IncomeDetailsView"
export default IncomeDetailsView
